// Shared values for the CTWA campaign flow (1 campaign → 1 ad set → 2–5 ads).

export const GOALS = [
  { value: 'CONVERSATIONS', label: 'Get WhatsApp conversations', desc: 'More people start a chat with you on WhatsApp' },
  { value: 'LEADS', label: 'Get leads on WhatsApp', desc: 'Collect enquiries from people likely to buy' },
];

export const SPECIAL_AD_CATEGORIES = [
  { value: 'NONE', label: 'None of these' },
  { value: 'FINANCIAL', label: 'Loans, credit or financial services' },
  { value: 'HOUSING', label: 'Housing' },
  { value: 'EMPLOYMENT', label: 'Jobs' },
  { value: 'ISSUES_ELECTIONS_POLITICS', label: 'Social issues, elections or politics' },
];

// Meta fixes age to 18–65+ and gender to All for these.
export const LOCKED_DEMOGRAPHIC_CATEGORIES = ['FINANCIAL', 'HOUSING', 'EMPLOYMENT'];
export const LOCKED_AGE = [18, 65];

export const MIN_ADS = 2;
export const MAX_ADS = 5;

export const AD_FORMATS = [
  { value: 'IMAGE', label: 'Image' },
  { value: 'CAROUSEL', label: 'Carousel' },
  { value: 'VIDEO', label: 'Video' },
];

export const MIN_CAROUSEL_CARDS = 2;
export const MAX_CAROUSEL_CARDS = 10;

// Must match ctwa.models.AspectRatio and the server's 1% tolerance.
export const ASPECT_RATIOS = [
  { value: '1:1', w: 1, h: 1 },
  { value: '4:5', w: 4, h: 5 },
  { value: '9:16', w: 9, h: 16 },
];
export const ASPECT_RATIO_TOLERANCE = 0.01;

export const PRIMARY_TEXT_RECOMMENDED = 125;
export const HEADLINE_MAX = 40;
export const AUTOFILL_MAX = 80;

// ponytail: short fixed list; switch to Meta's adcountry search if tenants advertise elsewhere.
export const COUNTRIES = [
  { code: 'IN', name: 'India' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SG', name: 'Singapore' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
];

// Meta only accepts 17–80 km around a city (0 = the city itself).
export const CITY_RADIUS_OPTIONS = [0, 17, 25, 40, 80];
export const PIN_RADIUS_DEFAULT = 5;
// Meta: loans, housing and jobs ads need at least this radius around every city and pin.
export const SPECIAL_CATEGORY_MIN_RADIUS_KM = 17;

export const SECTIONS = [
  { id: 'account', title: 'Account setup' },
  { id: 'objective', title: 'Campaign objective' },
  { id: 'placements', title: 'Placements' },
  { id: 'ads', title: 'Ads' },
  { id: 'targeting', title: 'Targeting' },
  { id: 'budget', title: 'Budget & schedule' },
  { id: 'autofill', title: 'Autofill & chatbot' },
];

// Bumped when the draft's form_data shape changes; older drafts reopen with only their name.
export const DRAFT_VERSION = 2;

let keySeq = 0;
export const newKey = () => `k${Date.now()}_${keySeq++}`;

export const emptyCard = () => ({ key: newKey(), file: null, previewUrl: '', headline: '', description: '', width: null, height: null, ratio: '' });

export const emptyAd = (n = 1) => ({
  key: newKey(),
  name: `Ad ${n}`,
  format: 'IMAGE',
  file: null,
  previewUrl: '',
  width: null,
  height: null,
  ratio: '',
  cards: [emptyCard(), emptyCard()],
  mediaAssetId: null, // set once uploaded; cleared whenever the media changes
  primaryText: '',
  headline: '',
  autofill: '',
  chatbot: '', // "nodebot:<id>" | "custom_chatbot:<id>" | '' (none)
});

export const initialForm = () => ({
  v: DRAFT_VERSION,
  name: '',
  account: { adAccountId: '', adAccountName: '', pageId: '', pageName: '', waNumberId: '', waNumber: '', waNumberName: '' },
  goal: 'CONVERSATIONS',
  specialAdCategory: 'NONE',
  placementMode: 'automatic',
  placements: [],
  ads: [emptyAd(1), emptyAd(2)],
  targeting: {
    advantageAudience: true,
    country: 'IN',
    locations: [], // { key, type: region|city|zip|custom, name, radiusKm?, latitude?, longitude? }
    ageMin: 18,
    ageMax: 65,
    gender: 'all',
    detailed: [], // { id, name, type }
  },
  budget: { daily: '', startDate: '', endMode: 'never', endDate: '' },
  autofillMode: 'all',
  autofillAll: 'Hi, I want to know more',
  chatbotMode: 'all',
  chatbotAll: '',
});
